<template>
  <li>
    <div class="order-info">
      <span
        v-show="item.statNm"
        class="c-util-button type-line-primary type-small type-round"
      >
        <span class="bold"> {{ item.statNm }} </span>
      </span>
      <ul class="list">
        <li class="item">
          <strong> 주문일자 : </strong>
          <span> {{ item.erdDat }} </span>
        </li>
        <li class="item">
          <strong> 페인트 프로 주문번호 : </strong>
          <span> {{ item.orderNo }} </span>
        </li>
        <li class="item" v-if="item.statCd != '0'">
          <strong> SAP 주문번호 : </strong>
          <span> {{ item.sapOrderNo }} </span>
        </li>
      </ul>
    </div>
    <div class="info-detail">
      <div class="address-info">
        <span class="c-round-flag type-gray">배송지</span>
        <p class="text">배송방법 : {{ item.dlvMthdNm }}</p>
        <p class="text">
          <template
            v-if="
              item.dlvMthdCd == 10 ||
              item.dlvMthdCd == 15 ||
              item.dlvMthdCd == 18 ||
              item.dlvMthdCd == 25
            "
          >
            {{ item.addr }}
          </template>
          <template v-if="item.dlvMthdCd == 20">
            {{ item.dlvBranchCd }}
          </template>
          <template v-if="item.dlvMthdCd == 30">
            {{ Utils.replace(item.werks, "노루페인트", "") }}
          </template>
        </p>
      </div>
      <div class="product-info">
        <p>
          {{ item.posnr }}
        </p>
        <!-- <em class="color-danger">1건</em> -->
      </div>
      <div class="price-info">
        <div class="price-info-item">
          <strong>주문금액</strong>
          <span>{{ Number(item.goodsPrc).toLocaleString() }}원</span>
        </div>
      </div>
      <div class="c-btn-area type-full">
        <button
          type="button"
          class="c-mo-button type-line-gray"
          @click="emit('detail', item)"
        >
          <span class="bold">주문상세</span>
        </button>
        <!-- <button
          v-if="item.statCd == 0"
          type="button"
          class="c-mo-button type-primary"
          @click="emit('cancel', item)"
        >
          <span class="bold">취소신청</span>
        </button> -->
        <button
          type="button"
          class="c-mo-button type-primary"
          @click="emit('reOrder', item)"
        >
          <span class="bold">다시주문</span>
        </button>
      </div>
    </div>
  </li>
</template>
<script setup>
import { defineProps, ref, defineEmits } from "vue";
import Utils from "@/js/utils";

const props = defineProps({
  item: {
    type: Object,
    require: true,
  },
});

const emit = defineEmits(["detail", "cancel", "reOrder"]);

const item = ref(props.item);
</script>
